import axios from 'axios'

axios.defaults.headers.common['X-Location'] = window.addiesaas.location.name
